module.exports = "/_next/static/images/rolex_model_background_grey_portrait-284a1703590fa7bcf131b3d5e87e657e.jpg";